import { RootState } from 'reducers/rootReducer';
import { UpdateState } from './type';

export const selectUpdates = (state: RootState): UpdateState => state.update;
export const selectIsLoading = (state: RootState): boolean => state.update.isLoading;
